export default {"src":"/_next/static/media/grid-white.8c6b310f.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};